import React from "react";

import loader from "assets/images/loader.gif";
import * as S from "./loader.styles";

export const Loader = () => (
  <S.LoadersWrap>
    <S.LoadersImage alt="loader" src={loader} />
  </S.LoadersWrap>
);
